import React, { useEffect, useState } from 'react';
import { createElement } from 'react';
import './index.scss';
import { Box, Button } from '@alifd/next';
import { entityMetadataUtil } from 'oadp-common';
import OadpAttributeSettingTransfer from '../common/oadp-attribute-setting-transfer';
import ConditionGroup from '../oadp-entity-button-read-condition/condition-group';
const OadpEntityButtonReadCondition = function OadpEntityButtonReadCondition({ children, name, id, entity, tableComponentRefId, defaultValue, label, style, type, size, onClick, queryAttributeList, disabled, __designMode, ...otherProps }) {
    const [condition, setConditionValue] = useState(defaultValue || {
        id: '0',
        operator: 'and',
        value: [
            {
                id: String(Date.now() + 1),
                attribute: '',
                operator: 'equals',
                valueType: 'MEMBER',
                value: '',
            }
        ]
    });
    const [attributeShowDataSource, setAttributeShowDataSource] = React.useState(queryAttributeList);
    const [attributeDataSource, setAttributeDataSource] = React.useState([]);
    const [operator, setOperator] = React.useState("and");
    useEffect(() => {
        const fetchAttributeData = async () => {
            try {
                console.log('OadpEntityButtonReadCondition componentDidMount props', { entity, tableComponentRefId });
                if (!entity) {
                    console.log('OadpEntityButtonReadCondition componentDidMount entity is undefined');
                    return;
                }
                const attributeData = await entityMetadataUtil.asyncSelectAttributeListWithReferByEntityId(entity);
                attributeData.list.forEach((item) => {
                    item.label = item.name || '';
                    item.value = item.id || '';
                });
                console.log('OadpEntityButtonReadCondition componentDidMount attributeData', attributeData.list);
                setAttributeDataSource(attributeData.list);
            }
            catch (error) {
                console.error('OadpEntityButtonReadCondition componentDidMount Failed to fetch field options:', error);
            }
        };
        fetchAttributeData();
    }, [entity]);
    const handleButtonClick = () => {
        if (__designMode === 'design') {
            console.log('design mode OadpEntityButtonReadCondition click');
            return;
        }
        if (onClick) {
            console.log('OadpEntityButtonReadCondition click condition', condition);
            onClick(condition);
        }
    };
    const handleAdd = (parentId, isGroup) => {
        const newItem = isGroup ? {
            id: String(Date.now()),
            operator: 'and',
            value: [{
                    id: String(Date.now() + 1),
                    attribute: '',
                    operator: 'equals',
                    valueType: 'MEMBER',
                    value: '',
                }, {
                    id: String(Date.now() + 2),
                    attribute: '',
                    operator: 'equals',
                    valueType: 'MEMBER',
                }]
        } : {
            id: String(Date.now()),
            attribute: '',
            operator: 'equals',
            valueType: 'MEMBER',
            value: '',
        };
        console.log("handleAdd newItem", newItem);
        const newData = addItemToParent(condition, parentId, newItem);
        console.log("handleAdd newData", newData);
        setConditionValue(newData);
    };
    const handleRemove = (id) => {
        const newData = removeItemById(condition, id);
        setConditionValue(newData);
    };
    const handleChange = (id, updates) => {
        console.log('handleChange with updates ', updates);
        const newData = updateConditionById(condition, id, updates);
        console.log('handleChange with newData ', newData);
        setConditionValue(newData);
    };
    const addItemToParent = (filterCondition, parentId, newItem) => {
        if (filterCondition.id === parentId) {
            return {
                ...filterCondition,
                value: [...(filterCondition.value || []), newItem]
            };
        }
        if (filterCondition.value) {
            return {
                ...filterCondition,
                value: addItemToParent(filterCondition.value, parentId, newItem)
            };
        }
        return filterCondition;
    };
    const removeItemById = (filterCondition, id) => {
        console.log('OadpEntityButtonReadCondition removeItemById ', filterCondition, id);
        if (!filterCondition.value) {
            return filterCondition;
        }
        if (!Array.isArray(filterCondition.value)) {
            return filterCondition;
        }
        console.log('OadpEntityButtonReadCondition removeItemById filterCondition.value ', filterCondition.value);
        return {
            ...filterCondition,
            value: filterCondition.value.reduce((acc, item) => {
                if (item.id === id) {
                    return acc;
                }
                if (item.value && Array.isArray(item.value)) {
                    return [...acc, {
                            ...item,
                            value: removeItemById(item, id).value
                        }];
                }
                return [...acc, item];
            }, [])
        };
    };
    const updateConditionById = (filterCondition, id, updates) => {
        console.log('updateConditionById with updates ', updates, filterCondition);
        let newFilterCondition = { ...filterCondition };
        if (filterCondition.id === id) {
            newFilterCondition = { ...filterCondition, ...updates };
        }
        if (newFilterCondition.value && Array.isArray(newFilterCondition.value)) {
            newFilterCondition.value = newFilterCondition.value.map((item) => {
                return updateConditionById(item, id, updates);
            });
        }
        return newFilterCondition;
    };
    const handleDialogOk = () => {
        console.log('OadpEntityButtonReadCondition handleDialogOk');
    };
    return (createElement(Box, { direction: "row", justify: 'start', align: 'center' },
        createElement(ConditionGroup, { condition: condition, attributeDataSource: attributeDataSource, onAdd: handleAdd, onRemove: handleRemove, onChange: handleChange, handleButtonClick: handleButtonClick }),
        createElement(Button, { type: 'primary', size: 'medium', onClick: handleButtonClick }, " \u6761\u4EF6\u67E5\u8BE2"),
        createElement(OadpAttributeSettingTransfer, { attributeDataSource: attributeDataSource, attributeShowDataSource: attributeShowDataSource, onConfirm: handleDialogOk, __designMode: __designMode })));
};
export default OadpEntityButtonReadCondition;
